import React from "react";
import { useNavigate } from "react-router-dom";
import { Planet, MoonStars, Question, UserCircle } from "@phosphor-icons/react";
import styles from "./NavigationBar.module.css";

interface NavigationBarProps {
  active: "home" | "forecast" | "astrolog" | "profile";
}

const NavigationBar: React.FC<NavigationBarProps> = ({ active }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <button
        className={`${styles.icon} ${active === "home" ? styles.active : ""}`}
        onClick={() => navigate("/natal-chart")}
      >
        <Planet />
      </button>
      <button
        className={`${styles.icon} ${active === "forecast" ? styles.active : ""}`}
        onClick={() => navigate("/forecast")}
      >
        <MoonStars />
      </button>
      <button
        className={`${styles.icon} ${active === "astrolog" ? styles.active : ""}`}
        onClick={() => navigate("/astrolog")}
      >
        <Question />
      </button>
      <button
        className={`${styles.icon} ${active === "profile" ? styles.active : ""}`}
        onClick={() => navigate("/profile")}
      >
        <UserCircle />
      </button>
    </div>
  );
};

export default NavigationBar;
